module.exports = __webpack_public_path__ + "img/zone150250.bab73778.png";